export default __webpack_public_path__ + "static/media/log_out_icon.337670fe.svg";